import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { FiMessageCircle, FiMoreVertical, FiTrendingUp } from 'react-icons/fi';
import { HOME_EASE, HomeFloat } from './HomeMotion';
import forumPhoto from '../../../images/home/forum-photo.png';
import avatarSarah from '../../../images/contacts/pic1.jpg';
import avatarJames from '../../../images/contacts/pic2.jpg';
import avatarEmily from '../../../images/contacts/pic3.jpg';
import avatarExtra from '../../../images/contacts/pic11.jpg';

const THREADS = [
  {
    title: 'Q4 Marketing Campaign Plan',
    author: 'Sarah Johnson',
    avatar: avatarSarah,
    extras: [avatarJames],
    replies: '24 replies',
    time: '2h ago',
    pinned: true,
  },
  {
    title: 'Product Roadmap Feedback',
    author: 'James Lee',
    avatar: avatarJames,
    extras: [avatarEmily],
    replies: '18 replies',
    time: '5h ago',
  },
  {
    title: 'New Feature Ideas',
    author: 'Emily Davis',
    avatar: avatarEmily,
    extras: [avatarExtra],
    replies: '12 replies',
    time: '1d ago',
  },
];

const BARS = [
  { label: 'May', height: 32 },
  { label: 'Jun', height: 44 },
  { label: 'Jul', height: 52 },
  { label: 'Aug', height: 68 },
  { label: 'Sep', height: 82 },
  { label: 'Oct', height: 100 },
];

const HomeForumVisual = () => {
  const reduce = useReducedMotion();

  return (
    <div className="home-forum-stage">
      <div className="home-forum-photo-wrap">
        <motion.img
          src={forumPhoto}
          alt="Team discussing work in a flowdo forum"
          className="home-forum-photo"
          draggable="false"
          initial={reduce ? false : { opacity: 0, scale: 0.98 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, amount: 0.28 }}
          transition={{ duration: 0.7, ease: HOME_EASE }}
        />
      </div>

      <HomeFloat
        className="home-float--forum-panel"
        cardClassName="home-float-card--forum-panel"
        enterDelay={0.22}
        inView
        drift={{ x: 4, y: -10, duration: 5.4, durationX: 6.8 }}
      >
        <header className="home-forum-panel-head">
          <span className="home-forum-panel-icon">
            <FiMessageCircle />
          </span>
          <strong>Discussion Forum</strong>
          <FiMoreVertical />
        </header>

        <div className="home-forum-tabs" aria-hidden="true">
          <span className="is-active">Trending</span>
          <span>Latest</span>
          <span>Mine</span>
        </div>

        <ul className="home-forum-threads">
          {THREADS.map((thread, index) => (
            <motion.li
              key={thread.title}
              initial={reduce ? false : { opacity: 0, y: 8 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: 0.35 + index * 0.1, ease: HOME_EASE }}
            >
              <div className="home-forum-thread-top">
                <strong>{thread.title}</strong>
                {thread.pinned ? <PinIcon /> : null}
              </div>
              <div className="home-forum-thread-meta">
                <span className="home-forum-avatars">
                  <img src={thread.avatar} alt="" />
                  {thread.extras.map((src) => (
                    <img key={src} src={src} alt="" />
                  ))}
                </span>
                <span>{thread.author}</span>
                <span>{thread.replies}</span>
                <span>{thread.time}</span>
              </div>
            </motion.li>
          ))}
        </ul>

        <div className="home-forum-chart">
          <p>Engagement Overview</p>
          <div className="home-forum-bars" role="img" aria-label="Forum engagement from May to October">
            {BARS.map((bar, index) => (
              <div key={bar.label} className="home-forum-bar">
                <span className="home-forum-bar-track">
                  <motion.i
                    initial={reduce ? false : { height: 0 }}
                    whileInView={{ height: `${bar.height}%` }}
                    viewport={{ once: true, amount: 0.4 }}
                    transition={{ duration: 0.7, delay: 0.4 + index * 0.08, ease: HOME_EASE }}
                  />
                </span>
                <small>{bar.label}</small>
              </div>
            ))}
          </div>
        </div>

        <div className="home-forum-foot">
          <span className="home-forum-foot-icon">
            <FiTrendingUp />
          </span>
          Forum activity is up 27% compared to last month.
        </div>
      </HomeFloat>
    </div>
  );
};

function PinIcon() {
  return (
    <svg className="home-forum-pin" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true">
      <path d="M10.2 1.6 8.8 3l.9 2.6-2.4 2.4-.7-.7-2.2 2.2.8.8-3.7 3.7.9.9 3.7-3.7.8.8 2.2-2.2-.7-.7 2.4-2.4 2.6.9 1.4-1.4-5.6-5.6Z" />
    </svg>
  );
}

export default HomeForumVisual;
